import React, { FC, Suspense } from 'react';
import ErrorBoundary from '../../atoms/errorBoundary';

const HiddenFields = React.lazy(() => import('./hiddenFields'));

const HiddenFieldsLazy: FC<{ isPublishUserSelection?: boolean }> = ({ isPublishUserSelection = false }) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={''}>
        <HiddenFields isPublishUserSelection={isPublishUserSelection} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default HiddenFieldsLazy;
